import { useState, useRef } from "react";
import { MediaRecorder, register } from 'extendable-media-recorder';
import { connect } from 'extendable-media-recorder-wav-encoder';
import axios from "axios";
import uuid from 'react-native-uuid';
import { useDispatch, useSelector } from 'react-redux'
import { setBnText, setEnText, setEntity, setResult, setSession, resetSession } from './asrSlice'
import Button from 'react-bootstrap/Button';
import { hideLoader, showLoader } from '../loader/loaderSlice';

const AudioRecorderNLP = () => {
    const dispatch = useDispatch()
    const [permission, setPermission] = useState(false);
    const mediaRecorder = useRef(null);
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [stream, setStream] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [audio, setAudio] = useState(null);

    const appToken = useSelector((state) => state.auth.appToken);

    const getMicrophonePermission = async () => {
        if ("MediaRecorder" in window) {
            try {
                await register(await connect());
                const streamData = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                setPermission(true);
                setStream(streamData);
                console.log("Permission is provided");
            } catch (err) {
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }
    };

    const startRecording = async () => {
        dispatch(resetSession());
        setRecordingStatus("recording");
        const media = new MediaRecorder(stream, { mimeType: 'audio/wav' });
        //set the MediaRecorder instance to the mediaRecorder ref
        mediaRecorder.current = media;
        mediaRecorder.current.start();
        let localAudioChunks = [];
        mediaRecorder.current.ondataavailable = (event) => {
            if (typeof event.data === "undefined") return;
            if (event.data.size === 0) return;
            localAudioChunks.push(event.data);
        };
        setAudioChunks(localAudioChunks);
    };

    const stopRecording = async () => {
        setRecordingStatus("inactive");
        mediaRecorder.current.stop();
        mediaRecorder.current.onstop = async () => {
            const audioBlob = new Blob(audioChunks, { type: audioChunks[0].type });
            const audioUrl = window.URL.createObjectURL(audioBlob);
            // fileName should be the session id
            const fileNameText = uuid.v4();
            const fileName = fileNameText + ".wav";
            const audioFile = new File([audioBlob], fileName);

            setAudio(audioUrl);
            setAudioChunks([]);

            uploadAudio(audioFile, fileNameText);

        };
    };

    const uploadAudio = async (audioFile, fileName) => {
        const formData = new FormData();
        formData.append("file", audioFile);     
        dispatch(showLoader());   

        // todo make url from config file
        axios
            .post(`${process.env.REACT_APP_BACKEND_URL}/api/upload-file-for-nlp`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "X-API-KEY": appToken
                },
            })
            .then((response) => {
                // handle the response
                console.log(response);
                dispatch(setBnText(response.data.bnInput));
                dispatch(setEnText(response.data.enInput));
                // var entity = "";
                // for (var i=0; i < response.data.slots.length; i++) {
                //     entity+=response.data.slots[i].entity;
                //     entity+=":\t";
                //     entity+=response.data.slots[i].rawValue;
                //     entity+=",\t\n";
                // } 
                // dispatch(setEntity(entity));
                dispatch(setResult(response.data.userProfiles))
                dispatch(hideLoader()); 
                dispatch(setSession(fileName));  
                
            })
            .catch((error) => {
                // handle errors
                console.log(error);
                dispatch(hideLoader());
                dispatch(resetSession()); 
            });
    };

    return (
        <div className='recorder mini-card'>
            <h4>Audio Recorder</h4>
            <main>
                <div className="audio-controls">
                    {!permission ? (                        
                        <Button
                            variant="outline-dark" size="sm" onClick={getMicrophonePermission}>Get Microphone</Button>
                    ) : null}
                    {permission && recordingStatus === "inactive" ? (
                        <Button
                            variant="outline-dark" size="sm" onClick={startRecording}>Start Recording</Button>
                    ) : null}
                    {recordingStatus === "recording" ? (
                        <Button
                            variant="outline-dark" size="sm" onClick={stopRecording}>Stop Recording</Button>
                    ) : null}
                </div>
                {audio ? (
                    <div className="audio-container">
                        <br />
                        <audio src={audio} controls></audio>                        
                    </div>
                ) : null}

            </main>
        </div>
    );
};


export default AudioRecorderNLP;